import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=382ae58c&scoped=true&"
import script from "./HowItWorks.vue?vue&type=script&lang=js&"
export * from "./HowItWorks.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=382ae58c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382ae58c",
  null
  
)

export default component.exports